import DateMaster from './date_master';

export default class WordMapper {
  static map(wordData) {

    return {
      wordText: wordData.word_text,
      partOfSpeech: wordData.part_of_speech,
      pronunciationFile: wordData.pronunciation_file,
      tacksCount: wordData.tacks_count,
      exampleText: wordData.example_text,
      definitions: wordData.definitions,
      tackedBy: wordData.tacked_by,
      tackedByWithMetaData: wordData.tacked_by_with_metadata,
      createdAt: DateMaster.parseUTC(wordData.created_at),
      updatedAt: DateMaster.parseUTC(wordData.updated_at),
      lastTackedAt: DateMaster.parseUTC(wordData.last_tacked_at)
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/utils/word_mapper.js